var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
if(login_form &&  recover_form){
  document.querySelector('.enable-login').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
  });
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
  });
}
document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
  editbutton.addEventListener('click',function(e){
    e.preventDefault();
    var address_id = this.dataset.addressid;
    document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
      if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
        editformdiv.classList.remove('active-form');
      }
    });
    document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
  });
});
if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}
document.querySelectorAll('.destroy_button').forEach(function(destroyButton){
  destroyButton.addEventListener('click',function(e){
    var destroyId = this.dataset.destroy;
    console.log(destroyId);
    Shopify.postLink(
      '/account/addresses/'+destroyId, 
      {'parameters': {'_method': 'delete'}}
    );
  });
});
if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}
if(document.querySelector('.add-address')){
  document.querySelector('.add-address').addEventListener('click',function(e){
    document.getElementById('address_form_new').classList.toggle('active-open-form');
  });
}



// account wishlist API
var accountWishlistMarkup =
  `<h4 class="p2">Wishlist (<span class="favourite-count"></span>)</h4>
  <div class="search-row">
  {{#products}}
    <div class="search-column">
      <div class="snippet-product-grid snippet-product-grid-search">
        <div class="grid-imagebox search_left">
          <a href="{{du}}" class="product-link">
            <div class="product-images"><img src="{{iu}}" alt="productimage" ></div>
          </a>
        </div>
        <div class="grid-meta search_center">
          <div>
            <p class="product_title"><a href="{{du}}">{{dt}}</a></p>
            <p class="variant_title">{{option2}}</p>
          </div>
          <div class="pro_var row">
            <div class="singal_var"></div>
          </div>
        </div>
        <div class="search_right">
          <div class="">
            <p class="product_price">{{cu}}{{pr}}</p>
          </div>
        </div>
      </div>
    </div>
    {{/products}}
  </div>
  <div class="new_add_btn">
    <a href="/pages/wishlist" class="btn p_black w_100 center_align">See all wishlist products</a>
  </div>
  `;
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist)
function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function(products) {
    //WishlistedProducts = structuredClone(products);
    console.log("products-->",products)
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
           var colorname = fullProductDetails.variants[j].option2;
           WishlistedProducts[i].option2 = colorname;
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        }
        if(i == (WishlistedProducts.length -1 )){
            const editSchoolName = (jsonData) => {
              return jsonData.map(item => {
              var temp = Object.assign({}, item);
              var newDT = temp.dt.split("-")[0];
              temp.dt = newDT;
              return temp;
              });
            }
            var updatedSchools = editSchoolName(WishlistedProducts);
            console.log('updatedSchools',updatedSchools)
            var wishlistContentsContainer = document.getElementById("wishlist-account-conatiner");
            var formattedWishlistedProducts = WishlistedProducts.map(function(p) {
            p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
            p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
            return p;
            });
            var productCardsMarkup = SwymUtils.renderTemplateString(accountWishlistMarkup, {
              products: updatedSchools
            });
            if(wishlistContentsContainer){
              wishlistContentsContainer.innerHTML = productCardsMarkup;
              
              countWishlist();
           
            } else{
            console.log("Container not found, Wishlist Page element not found");
            }
          }
      });
      
    }
 
  });

}
function countWishlist(){
  window._swat.fetch( function(r) {
    $('.favourite-count').html(r.length);
  });
}

